module.exports = __webpack_public_path__ + "static/media/phone_pin.c5689679.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vectors/phone_pin.svg
// module id = 525
// module chunks = 0